import type { ProcessStep } from '../types/content';

export const processSteps: ProcessStep[] = [
  {
    title: 'Tell Us About Your Pool',
    description: 'Send a few details and photos, or give us a call.',
  },
  {
    title: 'We Evaluate Your Project',
    description: 'We look at your pool in person and talk through what it needs.',
  },
  {
    title: 'Choose Your Upgrades',
    description: 'Pick your finish, tile, coping, and deck options with a clear estimate.',
  },
  {
    title: 'We Renovate',
    description: 'Our team handles the work and keeps you updated along the way.',
  },
  {
    title: 'Enjoy Your Pool Again',
    description: "We walk you through startup so you're ready to swim.",
  },
];
